import { connect } from 'react-redux';
import { State } from 'store/types';
import { addToWishlist, removeFromWishlist } from 'store/wishlist/action';
import View from './View';
import { selectBrandName } from 'store/product/selector';
import { showSignUp } from 'store/app/actions';
import { setInteraction } from 'store/searchListing/actions';

const mapStateToProps = (state: State) => {
  const { auth } = state;
  return {
    user: auth.user,
    brandName: selectBrandName(state),
  };
};

const mapDispatchToProps = {
  addToWishlist,
  removeFromWishlist,
  showSignUp,
  setInteraction,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
